
import { defineComponent } from 'vue'
export default defineComponent({
  name : 'ItemTopTable',
  props: {
    data: Array,
  },
})
